import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { DocmanFileRest } from '../services/docman.service.file';
import { UiService } from '../../../core/services/core.ui.service';
import { ModalComponent } from '../../../core/config/core.modal-helpers';

@Component({
  selector: 'file-delete-modal',
  template: require('./file.delete.modal.html')
})
export class FileDeleteModalComponent extends ModalComponent implements OnInit {
  @Input() file: any;

  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(
    private docmanFileRest: DocmanFileRest,
    private uiService: UiService
  ) {
    super();
  }

  ngOnInit() {}

  deleteFile() {
    this.docmanFileRest.deleteFile(this.file.docmanFile.id)
      .then((response: any) => {
        this.uiService.message.showSuccess(`Deleted file "${this.file.filesystem.fileName}"`);
        this.onDelete.emit({file: this.file});
      }, (err: any) => {
        this.uiService.message.showError(`Error deleting file "${this.file.filesystem.fileName}"`);
        this.onClose.emit();
      });
  }
}
